module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "min-app"
  }, [_c('p', [_vm._v("\n    link ->\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkUrl),
      expression: "linkUrl"
    }],
    staticClass: "width200",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.linkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openLink
    }
  }, [_vm._v("open")])]), _vm._v(" "), _c('p', [_vm._v("\n    telegramLink ->\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telegramLinkUrl),
      expression: "telegramLinkUrl"
    }],
    staticClass: "width200",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.telegramLinkUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telegramLinkUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openTelegramLink
    }
  }, [_vm._v("open")])]), _vm._v(" "), _c('p', [_vm._v("\n    msg: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg),
      expression: "msg"
    }],
    staticClass: "width100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.msg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.msg = $event.target.value
      }
    }
  }), _vm._v("\n    to chatId: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatId),
      expression: "chatId"
    }],
    staticClass: "width80",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chatId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.httpSendMsg
    }
  }, [_vm._v("send")])]), _vm._v(" "), _c('p', [_vm._v("\n    http -> get ->\n    api:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getApiMethod),
      expression: "getApiMethod"
    }],
    staticClass: "width50",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.getApiMethod)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getApiMethod = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.getReq
    }
  }, [_vm._v("click")])]), _vm._v(" "), (_vm.getResData) ? _c('div', {
    staticClass: "p"
  }, [_c('div', [_vm._v("get res:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getResData))])]) : _vm._e(), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.testHandler
    }
  }, [_vm._v("test click")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17d4517e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MinApp.vue
// module id = 852
// module chunks = 15